//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "SectionMunicipalitySliderExcursions",
  components: {
    EmptyEntityCardsSlider: () => import("@/components/common/EmptyEntityCardsSlider"),
    Section: () => import("@/components/common/Section/index"),
    Scroller: () => import("@/components/common/Scroller/index"),
    SliderWithBullets: () => import("@/components/common/SliderWithBullets/index"),
    ExcursionCard: () => import("@/components/common/ExcursionCard/index"),
  },
  computed: {
    ...mapGetters({
      cityId: 'municipality/id',
      excursions: "excursions/excursions",
      pending: "excursions/pending"
    }),
    show() {
      return this.pending || this?.excursions?.length > 0;
    }
  },
  mounted() {
    const payload = {
      clear: true,
      params: {
        city_id: this.cityId,
        resolution: "micro",
        count: 100500,
        lang: this.$i18n.locale
      }
    };
    if (this.cityId) {
      this.$store.dispatch("excursions/fetch", payload);
    }
  },
  methods: {
    avatar(item) {
      return item?.guide?.images[0] || item?.agency?.images[0] || "";
    }
  }
};
